import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {UtilityService} from '../_helpers/utility.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  constructor(private router: Router,
              private authenticationService: AuthenticationService,
              public utility: UtilityService) {}

  intercept(httpRequest: HttpRequest<any>, nextRequest: HttpHandler): Observable<HttpEvent<any>> {
    httpRequest = httpRequest.clone({
      headers: httpRequest.headers
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
        .set('Expires', 'Thu, 01 Jan 1970 00:00:00 GMT')
        .set('If-Modified-Since', '0')
        // .set('Accept', 'application/json')
        // .set('Content-Type', 'application/json')
    });


    return nextRequest.handle(httpRequest).pipe(tap(() => {},
      (error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
            console.error('Error Event');
          } else {
            switch (error.status) {
              case 401:     // login
                this.authenticationService.logout();
                this.router.navigate(['login']);
                break;
              case 403:     // forbidden
                this.router.navigate(['']);
                break;
              case 0: // server down
                this.router.navigate(['unknownerror']);
                break;
              default:
                const reason = error.error.msg ;
                const status = error.status;
                this.utility.showAlert('Hata : ' + status, reason , ToasterPosition.topRight);
                return throwError(error);
            }
          }
        } else {
          console.error('some thing else happened');
        }
      }));
  }
}


export enum ToasterPosition {
  topRight = 'toast-top-right',
  topLeft = 'toast-top-left',
  bottomRight = 'toast-bottom-right',
  bottomLeft= 'toast-bottom-left',
}
